import BiayaWorkshop from "./views/BiayaWorkshop";
import Module from "./Module";
import BiayaWorkshopDetail from "./views/BiayaWorkshopDetail";
import ModalBiayaWorkshopTolak from "./views/modal/ModalBiayaWorkshopTolak";
import ModalBiayaWorkshopSetujui from "./views/modal/ModalBiayaWorkshopSetujui";
import BiayaWorkshopCreate from "./views/BiayaWorkshopCreate";

const requireAuth = { requireAuth: true };

const route = {
    path: "/biaya-workshop",
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "",
            name: "BiayaWorkshop",
            component: BiayaWorkshop,
            meta: {
                ...requireAuth,
                accessKey: 'expenses.expensesWorkshop',
            }
        },
        {
            path: "create",
            name: "BiayaWorkshop.Create",
            component: BiayaWorkshopCreate,
            meta: {
                ...requireAuth,
                accessKey: 'expensesWorkshop.create'
            }
        },
        {
            path: "detail/:id",
            meta: requireAuth,
            component: Module,
            children: [
                {
                    path: "",
                    name: "BiayaWorkshop.Detail",
                    component: BiayaWorkshopDetail,
                    meta: {
                        ...requireAuth,
                        accessKey: 'expensesWorkshop.read',
                    }
                },
                {
                    path: "tolak",
                    name: "BiayaWorkshop.Detail.Tolak",
                    components: {
                        default: BiayaWorkshopDetail,
                        dialog: ModalBiayaWorkshopTolak,
                    },
                    meta: { 
                        requireAuth: true,
                        accessKey: 'expensesWorkshop.confirm',
                    },
                },
                {
                    path: "setuju",
                    name: "BiayaWorkshop.Detail.Setuju",
                    components: {
                        default: BiayaWorkshopDetail,
                        dialog: ModalBiayaWorkshopSetujui,
                    },
                    meta: { 
                        requireAuth: true,
                        accessKey: 'expensesWorkshop.confirm',
                    },
                },
                {
                    path: "delete",
                    name: "BiayaWorkshop.Detail.delete",
                    components: {
                        default: BiayaWorkshopDetail,
                        dialog: () => {
                            return import("./views/modal/ModalConfirmDelete.vue");
                        },
                    },
                    meta: { 
                        requireAuth: true,
                        accessKey: 'expensesWorkshop.delete',
                    },
                },
            ],
        },
    ],
};

export default (router) => {
    router.addRoutes([route]);
};
